import { STORE_IS_API_LOADING } from "actions"

export const initialState = {
  isApiLoading: false,
}

export const system = (state = initialState, action) => {
  switch (action.type) {
    case STORE_IS_API_LOADING:
      return { ...state, isApiLoading: action.payload }
    default:
      return state
  }
}

export default system
